import type { ChildColor } from "../_data/mock";

type Tone = ChildColor | "gray" | "green";

const toneClasses: Record<Tone, string> = {
  orange:
    "bg-[var(--child-1-light)] text-[var(--child-1-primary)] ring-[var(--child-1-light)]",
  blue: "bg-[var(--child-2-light)] text-[var(--child-2-primary)] ring-[var(--child-2-light)]",
  gray: "bg-[var(--surface-2)] text-[var(--text-2)] ring-[var(--border-1)]",
  green: "bg-emerald-100 text-emerald-700 ring-emerald-200",
};

const sizeClasses = {
  sm: "size-7 text-[11px]",
  md: "size-9 text-xs",
  lg: "size-12 text-sm",
  xl: "size-16 text-base",
};

export function Avatar({
  initials,
  photoUrl,
  alt = "",
  tone = "gray",
  size = "md",
  className = "",
}: {
  initials: string;
  photoUrl?: string;
  alt?: string;
  tone?: Tone;
  size?: keyof typeof sizeClasses;
  className?: string;
}) {
  if (photoUrl) {
    return (
      <span
        className={`inline-block shrink-0 overflow-hidden rounded-full bg-[var(--surface-2)] ring-1 ring-[var(--border-1)] ${sizeClasses[size]} ${className}`}
      >
        <img
          src={photoUrl}
          alt={alt}
          referrerPolicy="no-referrer"
          className="size-full object-cover"
        />
      </span>
    );
  }
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-full font-semibold ring-1 ring-inset ${toneClasses[tone]} ${sizeClasses[size]} ${className}`}
    >
      {initials.toUpperCase()}
    </span>
  );
}
